module.exports = __webpack_public_path__ + "static/img/335_TO8_2584_og.8903197.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/335_TO8_2584_og.jpg
// module id = whYg
// module chunks = 0